<template>
	<div>
		<v-row dense>
			<v-col v-for="t in tiles" :key="t.label" cols="6" md="4" lg="3">
				<v-card outlined class="io-tile" :class="{ 'io-click': t.tab }" @click="t.tab && $emit('tab', t.tab)">
					<div class="io-label">
						{{ t.label }}
						<v-tooltip v-if="t.hint" bottom max-width="320">
							<template v-slot:activator="{ on }">
								<v-icon x-small color="grey" v-on="on">mdi-information-outline</v-icon>
							</template>
							<span>{{ t.hint }}</span>
						</v-tooltip>
					</div>
					<div class="io-value" :class="t.color">{{ t.value }}</div>
					<div v-if="t.sub" class="io-sub">{{ t.sub }}</div>
				</v-card>
			</v-col>
		</v-row>

		<SectionCard title="Da riordinare per fornitore" icon="mdi-truck-outline" subtitle="quantità proposte o corrette a mano" no-padding class="mt-2" data-tour="suppliers">
			<v-simple-table dense>
				<thead>
					<tr>
						<th style="width: 44px"></th>
						<th>Fornitore</th>
						<th class="text-right">Prodotti</th>
						<th class="text-right">Costo stimato</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="s in suppliers.filter(x => x.products)" :key="s.supplierId || 'none'">
						<td class="pl-1 pr-0">
							<v-menu offset-y>
								<template v-slot:activator="{ on, attrs }">
									<v-btn icon small v-bind="attrs" title="Azioni" v-on="on"><v-icon small>mdi-dots-vertical</v-icon></v-btn>
								</template>
								<v-list dense>
									<v-list-item link @click="$emit('open', s)">
										<v-list-item-icon><v-icon small>mdi-format-list-bulleted</v-icon></v-list-item-icon>
										<v-list-item-title>Vedi e modifica le quantità</v-list-item-title>
									</v-list-item>
									<v-list-item link @click="$emit('print', s)">
										<v-list-item-icon><v-icon small>mdi-printer-outline</v-icon></v-list-item-icon>
										<v-list-item-title>Stampa la proposta d'ordine</v-list-item-title>
									</v-list-item>
									<v-list-item link @click="$emit('export', s)">
										<v-list-item-icon><v-icon small>mdi-arrow-collapse-down</v-icon></v-list-item-icon>
										<v-list-item-title>Esporta in Excel</v-list-item-title>
									</v-list-item>
								</v-list>
							</v-menu>
						</td>
						<td>{{ s.supplierName }}</td>
						<td class="text-right">{{ formatNumber(s.products) }}</td>
						<td class="text-right font-weight-medium">{{ formatEurCents(s.cost) }}</td>
					</tr>
					<tr v-if="!suppliers.some(x => x.products)">
						<td colspan="4" class="text-center grey--text py-4">Nessun prodotto da riordinare</td>
					</tr>
				</tbody>
			</v-simple-table>
			<div class="io-sub pa-3">
				Proposta = vendite degli ultimi 90 giorni × stagionalità dei giorni da coprire (consegna + copertura + sicurezza, da Impostazioni) meno il disponibile, arrotondata alla confezione. La
				stagionalità confronta, negli anni passati, i giorni da coprire con quelli appena trascorsi; se il prodotto ha poca storia usa la sua categoria.
			</div>
		</SectionCard>
	</div>
</template>

<script>
import SectionCard from '@/components/core/SectionCard.vue';
import { formatEurCents, formatNumber } from '../format';

export default {
	name: 'InventoryOverview',
	components: { SectionCard },
	props: {
		summary: { type: Object, default: () => ({}) },
		suppliers: { type: Array, default: () => [] },
	},
	computed: {
		tiles() {
			const s = this.summary || {};
			const abc = s.abc || {};
			return [
				{ label: 'Valore del magazzino (a costo)', value: formatEurCents(s.stockValue), sub: `${formatNumber(s.pieces)} pezzi/confezioni`, hint: 'Giacenza positiva × prezzo d’acquisto attuale.' },
				{ label: 'Valore a prezzo di vendita', value: formatEurCents(s.retailValue), sub: 'IVA inclusa' },
				{ label: 'Da riordinare', value: formatNumber(s.toReorder), sub: `costo stimato ${formatEurCents(s.reorderCost)}`, color: s.toReorder ? 'orange--text text--darken-2' : '', tab: 'reorder' },
				{ label: 'Esauriti', value: formatNumber(s.outOfStock), sub: 'giacenza a zero o sotto, con vendite o soglia', color: s.outOfStock ? 'red--text' : '' },
				{ label: 'Immobilizzati', value: formatNumber((s.dead90 || 0) + (s.dead180 || 0)), sub: `${formatEurCents(s.deadValue)} fermi · ${formatNumber(s.dead180)} oltre 180 gg`, tab: 'dead' },
				{
					label: 'Classe A',
					value: formatNumber(abc.A),
					sub: 'prodotti che fanno l’80% del fatturato annuo',
					hint: 'Classificazione ABC sul ricavo degli ultimi 12 mesi: A fino all’80%, B fino al 95%, C il resto.',
					tab: 'coverage',
				},
				{ label: 'Classe B', value: formatNumber(abc.B), sub: 'fino al 95% del fatturato' },
				{ label: 'Classe C', value: formatNumber(abc.C), sub: 'il resto: candidati a uscire dal catalogo' },
			];
		},
	},
	methods: { formatEurCents, formatNumber },
};
</script>

<style scoped>
.io-tile {
	border-radius: 10px !important;
	padding: 12px 14px;
	height: 100%;
}
.io-click {
	cursor: pointer;
}
.io-label,
.io-sub {
	font-size: 12px;
	color: #5f6b7a;
}
.io-value {
	font-size: 20px;
	font-weight: 600;
	margin-top: 2px;
}
</style>
